export function SkeletonCard({ className = "" }: { className?: string }) {
  return <div className={`skeleton skeleton-card ${className}`} aria-hidden="true" />;
}

export function SkeletonBlock({ lines = 4 }: { lines?: number }) {
  return (
    <div className="skeleton-block" aria-hidden="true">
      {Array.from({ length: lines }).map((_, index) => (
        <div key={index} className="skeleton skeleton-line" style={{ width: `${60 + ((index * 17) % 40)}%` }} />
      ))}
    </div>
  );
}
